import { evaluateCategoriesJa, evaluateCategoryKeys } from "../../../const";
import { useNavigate } from "react-router";
import { ChartProps } from "react-chartjs-2";

import { dashBoardPaths } from "../routes";
import { buildDashBoardPath } from "../../routes";
import { arraySum } from "../../../utils/array";
import useBID from "../../../utils/useBid";
import useTimelineData from "../../../repository/useTimelineData";
import dayjs from "dayjs";

const useCategoryPage = () => {
  const navigate = useNavigate();
  const bId = useBID();
  const { data, isLoading } = useTimelineData({
    bId,
    amount: 1,
    interval: "year",
    startAt: dayjs().subtract(1, "year").toDate(),
  });
  const categoryData = data;
  const chartCategoriesProps: ChartProps | null = categoryData
    ? {
        type: "bar",
        redraw: true,
        data: {
          labels: evaluateCategoriesJa.map((v) =>
            v.replace("ー", "丨").split("")
          ), // 縦書きのために文字列を配列化している。
          datasets: [
            {
              type: "bar",
              label: "",
              data: evaluateCategoryKeys.map((key) => {
                return arraySum(categoryData[key].neg.map((a) => a * -1));
              }),
              backgroundColor: "rgb(192, 75, 104)",
            },
            {
              type: "bar",
              label: "",
              data: evaluateCategoryKeys.map((key) => {
                return arraySum(categoryData[key].pos);
              }),
              backgroundColor: "rgb(75, 192, 75)",
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            title: {
              display: true,
              text: "カテゴリごとの評価",
            },
            legend: {
              display: false,
            },
            tooltip: {
              callbacks: {
                title: (ctx) => evaluateCategoriesJa[ctx[0].dataIndex],
                label: (ctx) =>
                  (ctx.raw as number) > 0
                    ? `ポジティブ${ctx.raw}件`
                    : `ネガティブ${(ctx.raw as number) * -1}件`,
              },
            },
          },
          scales: {
            y: {
              stacked: true,
            },
            x: {
              stacked: true,
            },
          },
          onClick: (_, el) => {
            if (el.length === 0) return;
            const categoryIndex = el[0].index;
            const isPositive = el[0].datasetIndex === 1;
            if (
              window.confirm(
                `${evaluateCategoriesJa[categoryIndex]}の${
                  isPositive ? "ポジティブ" : "ネガティブ"
                }なフィードバックを見ますか？`
              )
            ) {
              const path = `${buildDashBoardPath(bId)}/${
                dashBoardPaths.reviews
              }?category=${evaluateCategoryKeys[categoryIndex]}&eval=${
                isPositive ? "pos" : "neg"
              }`;
              navigate(path);
            }
          },
          onHover: function (e, el) {
            if (!el || el.length === 0) {
              window.document.getElementById("category-chart")!.style.cursor =
                "default";
            } else {
              window.document.getElementById("category-chart")!.style.cursor =
                "pointer";
            }
          },
        },
      }
    : null;

  return { chartCategoriesProps, isLoading };
};

export default useCategoryPage;
